import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { CalendarClock } from "lucide-react";
import { residentApi, errMsg } from "@/lib/api";
import { Card } from "@/components/common";
import { useResidentApi } from "@/pages/resident/useResidentApi";
import { VISIT_CLS, visitWhen } from "@/lib/visits";

export function MyVisits() {
  const { data, reload } = useResidentApi<any[]>("/resident/visits");
  if (!data?.length) return null;
  const cancel = async (id: string) => {
    if (!window.confirm("Cancel this visit?")) return;
    try { await residentApi.delete(`/resident/visits/${id}`); toast.success("Visit cancelled"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card className="p-4" data-testid="resident-my-visits">
      <p className="font-bold mb-2 flex items-center gap-2"><CalendarClock className="h-4 w-4 text-[#3d52a0]" />My visits</p>
      {data.map((v) => (
        <div key={v.id} className="py-2.5 border-b border-slate-100 last:border-0 flex items-center justify-between gap-2" data-testid={`visit-${v.id}`}>
          <Link to={`/resident/pg/${v.property_id}`} className="min-w-0">
            <p className="font-semibold truncate">{v.property_name}</p>
            <p className="text-xs text-slate-500" data-testid={`visit-when-${v.id}`}>{visitWhen(v)}</p>
          </Link>
          <div className="flex items-center gap-2 shrink-0">
            <span data-testid={`visit-status-${v.id}`} className={`text-xs font-semibold rounded-full border px-2.5 py-1 capitalize ${VISIT_CLS[v.status]}`}>{v.status}</span>
            {["pending", "confirmed"].includes(v.status) && <button data-testid={`visit-cancel-${v.id}`} onClick={() => cancel(v.id)} className="text-xs font-semibold text-slate-500 underline">Cancel</button>}
          </div>
        </div>
      ))}
    </Card>
  );
}
